import { writable } from "svelte/store";

const urlParams = new URLSearchParams(window.location.search);
const DEFAULT_URL = "https://regadata2020.vercel.app/vg2020/bestof/full.json";
const TEST_URL = "http://127.0.0.1:8082/vg2020/bestof/full.json";

export const bestofs = writable([]);
export const lang = writable("fr");
export const isRanking = writable(urlParams.has("ranking"));

if (urlParams.has("lang") && urlParams.get("lang") !== undefined) {
  const tmp = urlParams.get("lang") === "en" ? "en" : "fr";
  lang.set(tmp);
}

export const fetchFullBestof = async () => {
  const res = await fetch(DEFAULT_URL);
  // const res = await fetch(TEST_URL);
  const sources = await res.json();
  bestofs.set(sources);
};
